import React, {useState} from 'react';
import Fab from '@mui/material/Fab';
import { useTheme } from '@mui/material/styles';
import i18next from 'i18next';

export default function LangSelector() {
    const theme = useTheme();
    const [currentLanguage, setCurrentLanguage] = useState(i18next.language);
    
    const handleLanguageChange = () => {
        i18next.changeLanguage(i18next.language === "en" ? "fr" : "en");
        setCurrentLanguage(i18next.language);
    };

    return ( 
        <div>
            <Fab
                onClick={() => {
                    handleLanguageChange()
                  }}
                title={i18next.language}
                sx={{
                    position: 'fixed',
                    top: theme.spacing(1),
                    right: theme.spacing(2),
                    backgroundColor: theme.palette.default.main,
                    color: theme.palette.primary.contrastText,
                    borderRadius: '50%',
                    width: '36px',
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.85rem',
                }}
            >
                {currentLanguage}
            </Fab>
        </div>
    )
}